import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

export function useSavePrescription() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((prescription) => {
    setSaving(true);
    return quarkusApi
      .post('/prescriptions', prescription, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
